module.exports = __webpack_public_path__ + "static/img/background.1a8640bf.svg";